<section class="cz-survey" [@fadeInUpAnimation]>
  <div class="survey-start-end" *ngIf="!surveyStarted">
    <header class="row header">
      <div class="col-xs-12">
        <h1 class="page-title" [innerHTML]="'$survey_page_heading' | translate"></h1>
        <p class="subtitle" [innerHTML]="'$survey_page_sub_heading' | translate"></p>
      </div>
    </header>
    <div class="row">
      <div class="col-xs-12">
        <mat-card *ngIf="currentSurvey$ | async as survey" class="message-container">
          <p *ngIf="!surveyInProgress && !surveyComplete" [innerHTML]="'$survey_start_text' | translate"></p>
          <p *ngIf="surveyInProgress && !surveyComplete" [innerHTML]="'$survey_in_progress_text' | translate">
            <span class="font-weight-bold">{{survey.date | date: 'shortDate'}}</span>
          </p>
          <p *ngIf="surveyInProgress && !surveyComplete" class="p" [innerHTML]="'$survey_finish_text' | translate"></p>
          <div *ngIf="surveyComplete">
            <h5 [innerHTML]="'$survey_completed_text_heading' | translate"></h5>
            <p [innerHTML]="'$survey_completed_text' | translate"></p>
          </div>
          <div class="row end-xs">
            <div class="col-6-xs">
              <p *ngIf="!surveyInProgress && !surveyComplete">
                <button mat-flat-button color="accent" (click)="startNewSurvey()" [innerHTML]="'$btn_start' | translate"></button>
              </p>
              <p *ngIf="surveyInProgress && !surveyComplete">
                <button mat-button color="accent" (click)="startNewSurvey()" [innerHTML]="'$btn_start_new' | translate"></button>
                <button mat-flat-button color="accent" (click)="startSurvey()" [innerHTML]="'$btn_finish' | translate"></button>
              </p>
              <p *ngIf="surveyComplete">
                <button mat-flat-button color="accent" (click)="continueToRecommendations()" [innerHTML]="'$btn_continue' | translate"></button>
              </p>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
  <cz-survey-stepper
    *ngIf="surveyStarted"
    [survey]="currentSurvey$ | async"
    [surveyStarted]="surveyStarted"
    [surveyInProgress]="surveyInProgress"
    [surveyComplete]="surveyComplete"
    [surveyImagePath]="surveyImagePath"
    [surveyProgress$]="surveyProgress$ | async"
    [task]="task"
    (endSurvey)="endSurvey()"
  ></cz-survey-stepper>
</section>
